import React, { PureComponent } from 'react';

/**
 * Render post title in the Entity Header
 */
class PostTitle extends PureComponent {
	/**
	 * Constructor
	 *
	 * @param {Object} props
	 */
	constructor( props ) {
		super( props );

		/**
		 * Post title data
		 */
		this.state = {
			original_post_title: LearnDashData.post_data
				? LearnDashData.post_data.builder_post_title
				: '',
			post_title: LearnDashData.post_data
				? LearnDashData.post_data.builder_post_title
				: '',
		};
	}

	/**
	 * Update header title when updating title in Gutenberg or classic editor
	 */
	componentDidMount() {
		const self = this;
		// Look for changes in #editor in Gutenberg
		const editorContainer = document.getElementById( 'editor' );
		if ( editorContainer ) {
			const observer = new MutationObserver( () => {
				const titleField = editorContainer.querySelector(
					'.editor-post-title__input'
				);
				if ( titleField ) {
					titleField.addEventListener( 'input', function ( e ) {
						self.setState( { post_title: e.target.value } );
					} );
					observer.disconnect();
				}
			} );
			const observerConfig = {
				attributes: true,
				childList: true,
				characterData: false,
			};
			observer.observe( editorContainer, observerConfig );
		} else {
			const titleFieldClassic = document.getElementById( 'title' );
			if ( titleFieldClassic ) {
				titleFieldClassic.addEventListener( 'input', function ( e ) {
					self.setState( { post_title: e.target.value } );
				} );
			}
		}
	}

	/**
	 * Render the post title component
	 */
	render() {
		const { original_post_title, post_title } = this.state;
		return (
			<h1
				dangerouslySetInnerHTML={ {
					__html:
						'' !== post_title ? post_title : original_post_title,
				} }
			/>
		);
	}
}

export default PostTitle;
